import CE from "../docs/QC certs/CE.pdf";
import CeImg from "../images/cert/CE.jpeg";
import OH from "../docs/QC certs/OHSMS.pdf";
import OHImg from "../images/cert/HNS.png";
import QMS from "../docs/QC certs/QMS.pdf";
import QMSImg from "../images/cert/QMS.png";
import ROHS from "../docs/QC certs/ROHS.pdf";
import ROHSImg from "../images/cert/ROHS.png";
import UL from "../docs/QC certs/UL.pdf";
import ULImg from "../images/cert/UL.jpg";


const Certificates = () => (
  <div className='transparent-card-wrapper full-width'>
    <div className='transparent-card center-card'>
      <h3 style={{ color: "#e47931" }}>Quality Certificates</h3>
    </div>
    <div className='transparent-card center-card'>
      <div className="client-grid">
        <div className="client-card">
          <a className="cert-link" href={CE} target="_blank">
            <img src={CeImg} alt="CE" />
            <div>Conformité Européenne (CE)</div>
          </a>
        </div>
        <div className="client-card">
          <a className="cert-link" href={OH} target="_blank">
            <img src={OHImg} alt="HNS" />
            <div>Health and Safety</div>
          </a>
        </div>
        <div className="client-card">
          <a className="cert-link" href={QMS} target="_blank">
            <img src={QMSImg} alt="QMS" />
            <div>Quality Management</div>
          </a>
        </div>
        <div className="client-card">
          <a className="cert-link" href={ROHS} target="_blank">
            <img src={ROHSImg} alt="ROHS" />
            <div>RoHS</div>
          </a>
        </div>
        <div className="client-card">
          <a className="cert-link" href={UL} target="_blank">
            <img src={ULImg} alt="UL" />
            <div>UL Certificate</div>
          </a>
        </div>
        {/* <div className="client-card"><img src={abb} alt="abb" /></div>
                <div className="client-card"><img src={apc} alt="apc" /></div>
                <div className="client-card"><img src={axora} alt="axora" /></div>
                <div className="client-card"><img src={coldair} alt="coldair" /></div>
                <div className="client-card"><img src={ge} alt="ge" /></div>
                <div className="client-card"><img src={gm} alt="gm" /></div>
                <div className="client-card"><img src={gmr} alt="gmr" /></div>
                <div className="client-card"><img src={isro} alt="isro" /></div>
                <div className="client-card"><img src={ntpc} alt="ntpc" /></div>
                <div className="client-card"><img src={parrys} alt="parrys" /></div>
                <div className="client-card"><img src={radisson} alt="radisson" /></div>
                <div className="client-card"><img src={sail} alt="sail" /></div>
                <div className="client-card"><img src={schneider} alt="schneider" /></div>
                <div className="client-card"><img src={sumadhura} alt="sumadhura" /></div> */}
      </div>
    </div>
  </div>
);
export default Certificates;